import * as Moment from "moment";
const toTeaserProps = (p)=>({
        headingLevel: 'h2',
        title: p.Title,
        intro: p.Description,
        label: Moment(p.PublicationDate).format('LL'),
        imageAlt: p.ImageAlt,
        imageUrl: p.ImageUrls['420x320'],
        imageUrlFallback: p.ImageUrls['4x3'],
        imageUrlLarge: p.ImageUrls['840x640'],
        linkUrl: p.Url,
        key: `blog_posts_item_${p.EntityId}`,
        categories: p.Categories
    });
export const getBlogs = (page, pageSize, category)=>async ()=>{
        let headers = new Headers();
        headers.append('X-XSRF-TOKEN', document.getElementsByName("__RequestVerificationToken")[0].value);
        const response = await fetch(`/api/v1/search/list?type=blog-posts&page=${page}&pageSize=${pageSize}${category ? '&category=' + category : ''}`, {
            headers
        });
        if (response.ok) {
            const body = await response.json();
            return {
                kind: "result",
                value: {
                    totalResults: body.Count,
                    posts: body.Results.map(toTeaserProps)
                },
                status: response.status
            };
        }
        return {
            kind: "failed",
            status: response.status
        };
    };
